import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMissedCallCount } from 'hooks/useMissedCallCount';

import useVoiceBroadcastChannel from 'components/Voice/useVoiceBroadcastChannel';

import { getProUuid } from '../../../Resources/Pro/ProData';
import getUnreadMessages from '../../../Resources/Sendbird/getUnreadMessages';

export const useMessageCount = () => {
  useVoiceBroadcastChannel();
  const proId = useSelector(getProUuid);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [missedCallCountReady, missedCallCount] = useMissedCallCount();

  useEffect(() => {
    if (proId) {
      getUnreadMessages(proId)
        .then((res) => {
          setUnreadMessages(res);
        })
        .catch(() => setUnreadMessages(0));
    }
  }, [proId]);

  return !missedCallCountReady ? 0 : missedCallCount + unreadMessages;
};
